import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { select } from '@angular-redux/store';
import { Observable, throwError } from 'rxjs';
import { Themes } from 'src/app/core/themes/themes.model';
import { ThemesActionService } from 'src/app/core/themes/themes.action';
import { BreadcrumbService } from 'angular-crumbs';
import { ApiService } from 'src/app/services/api.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, tap, first } from 'rxjs/operators';
import { SuccessRequestComponent } from 'src/app/shared/success-request/success-request.component';
import { FailRequestComponent } from 'src/app/shared/fail-request/fail-request.component';

export interface DialogData {
  id: any;
  theme_name: object;
  current_lang: string;
}

@Component({
  selector: 'app-theme-singolo',
  templateUrl: './theme-singolo.component.html',
  styleUrls: ['./theme-singolo.component.scss']
})
export class ThemeSingoloComponent implements OnInit, OnDestroy {
  @select(['theme', 'current'])
  theme_current$: Observable<Themes>;
  theme_current: Themes;

  current_lang = 'it';

  current_id: any;
  current_name: object;
  loading = false;

  constructor(private titleService: Title,
              private route: Router,
              private activateroute: ActivatedRoute,
              private apiservice: ApiService,
              private themeAction: ThemesActionService,
              private breadcrumbservice: BreadcrumbService,
              private translate: TranslateService,
              public dialog: MatDialog) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.translate.use(this.translate.currentLang);
    } else {
      this.translate.use('it');
    }
    this.translate.get('breadcrumb.admin_single_theme').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe(() => {
      this.changeLangFunction();
    });
  }

  ngOnInit(): void {
    this.theme_current$.pipe(
      first(),
      tap((theme) => {
        this.theme_current = theme;
        this.current_id = this.theme_current.id;
        this.current_name = this.theme_current.name;
        this.changeLangFunction();
      })
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.themeAction.setThemesCurrent(null);
  }

  elemDelete() {
    this.dialog.open(DeleteThemeDialogContent, {
      width: '450px',
      data: {
        id: this.current_id,
        theme_name: this.current_name,
        current_lang: this.current_lang
      }
    });
  }

  changeLangFunction(): void {
    this.current_lang = this.translate.currentLang;
    this.titleService.setTitle(this.theme_current.name[this.current_lang] + ' - PRIMIS');
    this.breadcrumbservice.changeBreadcrumb(this.activateroute.snapshot, this.theme_current.name[this.current_lang]);
  }

  routerFunction(path_to_new_page) {
    this.route.navigate([path_to_new_page]);
  }

  saveTheme() {
    this.loading = true;
    this.apiservice.modifyTheme(this.theme_current).pipe(
      tap((x: any) => {
        if (x && !x.error) {
          this.themeAction.addOrUpdateThemes(x);
          this.loading = false;
          const dialogRef = this.dialog.open(SuccessRequestComponent, {
            width: '450px'
          });
          dialogRef.afterClosed().subscribe(() => this.routerFunction('/lista-percorsi-tematici'));
        }
      }),
      catchError(error => {
        this.loading = false;
        this.dialog.open(FailRequestComponent, {
          width: '450px'
        });
        return throwError(error);
      })
    ).subscribe();
  }

  saveButtonDisabled() {
    const isValid = !!this.theme_current.name.it && !!this.theme_current.name.sl && !!this.theme_current.name.sl;
    return !isValid;
  }
}

@Component({
  selector: 'deletetheme-dialog-content',
  templateUrl: 'deletetheme-dialog-content.html',
  styleUrls: ['./theme-singolo.component.scss']
})
export class DeleteThemeDialogContent {
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<DeleteThemeDialogContent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private apiservice: ApiService,
    private themeAction: ThemesActionService,
    private route: Router,
    public dialog: MatDialog) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteTheme() {
    this.loading = true;
    let theme_id = this.data.id;
    this.apiservice.deleteTheme(theme_id).pipe(
      tap((x: any) => {
        this.themeAction.deleteThemes(theme_id);
        this.loading = false;
        this.dialogRef.close();
        if (x && !x.error) {
          const dialogRef = this.dialog.open(SuccessRequestComponent, {
            width: '450px'
          });
          dialogRef.afterClosed().subscribe(() => this.routerFunction('/lista-percorsi-tematici'));
        }
      }),
      catchError(error => {
        this.loading = false;
        this.dialog.open(FailRequestComponent, {
          width: '450px'
        });
        return throwError(error);
      })
    ).subscribe();
  }

  routerFunction(path_to_new_page) {
    this.route.navigate([path_to_new_page]);
  }
}
